import { Component, Input, ChangeDetectionStrategy } from "@angular/core";
import { TranslocoPipe } from "@jsverse/transloco";

@Component({
  imports: [TranslocoPipe],
  selector: "loren-key-value",
  standalone: true,
  styleUrls: ["./loren-key-value.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: "./loren-key-value.component.html",
})
export class LorenKeyValueComponent {
  @Input() key: string;
  @Input() value: string;
}
